import { render } from "./TheConfirmDialog.vue?vue&type=template&id=70877d3a"
import script from "./TheConfirmDialog.vue?vue&type=script&lang=js"
export * from "./TheConfirmDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__